import { sdk as imageClientSDK } from '@wix/image-kit';

import { type Image } from '../types';

export function getImageURL(
  { id, width, height }: Image,
  targetWidth: string | number,
  targetHeight: string | number,
  fit: 'fill' | 'fit' = 'fill',
) {
  const urlFunction =
    fit === 'fit'
      ? imageClientSDK.getScaleToFitImageURL
      : imageClientSDK.getScaleToFillImageURL;

  return urlFunction(
    id!,
    width!,
    height!,
    typeof targetWidth === 'number' ? targetWidth : parseInt(targetWidth, 10),
    typeof targetHeight === 'number'
      ? targetHeight
      : parseInt(targetHeight, 10),
  );
}
